import { apiFetch } from "./apiClient";

export async function getRcRouters() {
  const res = await apiFetch("/api/services/rc-devices/routers");
  if (!res.ok) {
    throw new Error("Failed to fetch router devices");
  }
  const payload = await res.json();
  return Array.isArray(payload?.data) ? payload.data : [];
}
